<template>
    <div class="tx-block-overlay" :class="[{'block-active':active}]">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'TxBlockOverlay',
        props: {
            active: {
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tx-block-overlay {
        &.block-active {
            pointer-events: none;

            ::v-deep .leaflet-marker-icon {
                pointer-events: none !important;
            }

            ::v-deep * {
                user-select: none;
            }
        }
    }
</style>